/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an Entity could not be deselecteded
 * @export
 * @class EntityCouldNotDeselectEntityError
 * @extends {Error}
 */
export class EntityCouldNotDeselectEntityError extends Error {
  /**
   * Creates an instance of EntityCouldNotDeselectEntityError
   * @param {string} message The Error `message`
   * @memberof EntityCouldNotDeselectEntityError
   */
  constructor(message) {
    super(message);
    this.name = `EntityCouldNotDeselectEntityError`;
  }
}

/**
 * Called when an Entity could not be deselecteded
 * @param {sting} id The `id` of the entity to deselect
 * @returns {never} never
 */
const throwEntityCouldNotDeselectEntityError = (id) => {
  throw new EntityCouldNotDeselectEntityError(
    stripIndent(`
    Can not deselect entity with id: "${id}".
    Entity does not exist.
    Has it been added?
    `),
  );
};

export default throwEntityCouldNotDeselectEntityError;
